import type {
    ComponentChildren,
} from "preact";
import {
    LoadingSpinner,
} from "./LoadingSpinner.tsx";

type FullPageLoadingProps = {
    message?: string;
};

export const FullPageLoading = ({
    message,
}: FullPageLoadingProps): ComponentChildren => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-bg-primary overflow-y-auto [scrollbar-gutter:stable]">
            <div className="text-center">
                <LoadingSpinner size="lg" />
                {message && (
                    <p className="text-text-secondary text-sm mt-4">
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
};
